import type { POSPStatus } from '@/types';

export const ACTIVATION_STEPS: { key: POSPStatus; label: string }[] = [
  { key: 'pending', label: 'Pending' },
  { key: 'documents_uploaded', label: 'Documents Uploaded' },
  { key: 'under_review', label: 'Under Review' },
  { key: 'approved', label: 'Approved' },
  { key: 'active', label: 'Active' },
];

export const REQUIRED_DOCUMENTS = [
  { type: 'pan_card', label: 'PAN Card' },
  { type: 'aadhaar_front', label: 'Aadhaar (Front)' },
  { type: 'photo', label: 'Photo' },
  { type: 'irdai_certificate', label: 'IRDAI Certificate' },
];

export function getStepIndex(status: POSPStatus): number {
  return ACTIVATION_STEPS.findIndex((s) => s.key === status);
}

export function requiredDocsComplete(docs: { document_type: string }[]): boolean {
  const uploaded = new Set(docs.map((d) => d.document_type));
  return REQUIRED_DOCUMENTS.every((r) => uploaded.has(r.type));
}

export function canUploadDocs(status: POSPStatus): boolean {
  return status === 'pending' || status === 'rejected';
}
